class lovestoryForm {
    constructor() {
        this.container = document.querySelector('[data-lovestoryformparent]');
        this.form = document.querySelector('[data-lovestoryForm]');
        this.submitBtn = document.querySelector('[data-lovestoryForm] button[type="submit"]');
        this.fileUpload = document.querySelector('[data-lovestoryForm] input[name="reference-image"]');
        this.thankyouScreen = document.querySelector('[data-lovestoryformparent] .thank_you_screen');
        this.scrollToFormBtns = document.querySelectorAll('[data-openCustomForm], a[href="#openCustomRequestForm"]');
        this.countryDropdown = document.querySelector("select#AddressCountry_New");
        this.countryDropdown.addEventListener("change", this.changeCity.bind(this));
        const requiredSteps = Array.from(this.form.querySelectorAll('.required-step'));
        this.visibleForm = document.querySelector("[data-thankYouBlockcloseBtn]"); 
        this.stateDropDown = document.querySelector("select#AddressProvince_New");
        this.requiredKeys = requiredSteps.map(step => step.dataset.key).filter(key => key !== null);
        this._setupEventListeners();
    }

    /**
     * Bind click events on toggle button
     */
    changeCity() {
        // Get the selected country option
        const selectedOption = this.countryDropdown.options[this.countryDropdown.selectedIndex];
    
        // Get the 'data-provinces' attribute, which should be a JSON string
        const provinceDataString = selectedOption.getAttribute('data-provinces');
    
        // Parse the JSON string into an array of arrays
        let provinceData = [];
        try {
            provinceData = JSON.parse(provinceDataString);  // Convert the JSON string into an array
        } catch (error) {
            console.error("Error parsing data-provinces:", error);
            return;  // Exit the function if there's an error in parsing
        }
    
        // Clear existing options in the state dropdown
        this.stateDropDown.innerHTML = "";
    
        // Add a default "Select a Province" option using template literal
        this.stateDropDown.innerHTML += `<option value="">Select a Province</option>`;
    
        // Loop over the province data and create options for the state dropdown
        provinceData.forEach(([value, label]) => {
            const isSelected = provinceDataString.includes(value);  // Check if the province should be selected
            const selectedAttribute = isSelected ? 'selected' : '';  // Set 'selected' if it matches the provinceData
    
            // Use template literals to create the option and append it
            this.stateDropDown.innerHTML += `
                <option value="${value}" ${selectedAttribute}>${label}</option>
            `;
        });
    }
    
    
    _setupEventListeners() {
        this.form.addEventListener('submit', (evt)=>{
            evt.preventDefault();
            let validForm = this._validForSubmission();
            if(!validForm) return;

            this._submitForm(evt);
        });
        this.form.addEventListener('input', (_evt) =>{
            let invalidEle = this.form.querySelectorAll('.required-step.is-invalid');
            invalidEle.forEach(ele => ele.classList.remove('is-invalid'));
        });
        this.scrollToFormBtns.forEach(btn => {
            btn.addEventListener('click', (evt)=> {
                evt.preventDefault();
                this.form.scrollIntoView({ behavior: "smooth", block: "nearest"});
            });
        });
        if(this.fileUpload) this.fileUpload.addEventListener('change', this._manageFileUpload.bind(this));
        if(this.datepicker){
            let lookForFlatpickr = setInterval(() => {
                if(typeof flatpickr == 'function'){
                    this.datepicker.flatpickr({
                        disableMobile: "true",
                        minDate: this.datepicker.min
                    });
                    clearInterval(lookForFlatpickr);
                } 
            }, 100);
        }
        this.visibleForm.addEventListener("click",(event)=>{
                this._openForm(event)
        })
    }

    _validForSubmission(){
        const formData = new FormData(this.form);
        let validInputs = true;
        this.requiredKeys.forEach((key) => {
            let value = (formData.get(key) != null && formData.get(key) != undefined) ? formData.get(key).trim() : '';
            if(value.length == 0) {
                validInputs = false;
                let element = this.form.querySelector(`[name="${key}"]`);
                if(element) element.closest('.required-step').classList.add('is-invalid');
            }
        });

        if(!validInputs){            
            window.notificationEle.updateNotification('Input required!', 'Please fill in required details to submit the request.', {
                type: 'error',
                timeout: 10000
            });
            return false;
        }else if(!Utility.validateEmail(formData.get('email'))){
            window.notificationEle.updateNotification('Invalid email!', 'Please provide valid email', {
                type: 'error',
                timeout: 10000
            });
            return false;
        }

        return true;
    }

    async _submitForm(event){
        event.preventDefault();
        let formData = new FormData(this.form);
        let email = formData.get('email');
        let properties = {};

        if(!Utility.validateEmail(email)){
            window.notificationEle.updateNotification('Input required!', 'Please provide valid email to submit selection.', {
                type: 'error',
                timeout: 5000
            });
            return;
        }

        // Collect profile attributes
        let profileAttributes = {
            email: formData.get('email'),
            first_name: formData.get('first_name')
        }
        // if(formData.get('phone_number') != '') profileAttributes['phone_number'] = formData.get('phone_number');
        
        // Collect custom design request event properties
        for(let [key, value] of formData.entries()){
            if(key == 'reference-image') {
                value = this.form.querySelector('input[name="reference-image"]').dataset.cdn || '';
            }

            let current = properties[key];
            if(key != 'first_name' && key != 'last_name' && key != 'email' && value != null){
                if(current == undefined){
                    properties[key] = value.trim();
                }else{
                    properties[key] = `${properties[key]},${value.trim()}`;
                }
            }
        }

        this.submitBtn.disabled = true;
        const eventData = {
            type: 'event',
            attributes: {
                properties: properties,
                metric: {data: {type: 'metric', attributes: {name: 'Tell us love story form submitted'}}},
                profile: {
                    data: {
                        type: 'profile',
                        attributes: profileAttributes
                    }
                }
            }
        };

        try {
            let fetchResponse = await this._registerKlaviyoEvt(eventData);
            if(fetchResponse.ok){
                this.container.classList.add('show-thankyou-screen');   
                // this._trackConversion();
                this.thankyouScreen.scrollIntoView({ behavior: "smooth", block: "nearest"}); 
            }else{
                let errRes = (typeof fetchResponse == 'object') ? fetchResponse : JSON.parse(fetchResponse);
                let title = (errRes.errors) ? errRes.errors[0].title : 'Invalid Input';
                let detail = (errRes.errors) ? errRes.errors[0].detail : 'Provide valid details';
                window.notificationEle.updateNotification(title, detail, {
                    type: 'error',
                    timeout: 10000
                });
                this.submitBtn.removeAttribute('disabled');
            }
        }catch(error){
            this.submitBtn.removeAttribute('disabled');
            window.notificationEle.updateNotification('Something went wrong!', JSON.stringify(error), {
                type: 'error',
                timeout: 10000
            });
            throw error;
        }
    }

    _openForm(event){
        this.container.classList?.remove('show-thankyou-screen');   
    }

    async _registerKlaviyoEvt(eventData){
        const apiResponse = await fetch("https://a.klaviyo.com/client/events/?company_id=UGMHdn", {
            method: "POST",
            headers: {'revision': '2024-05-15', 'content-type': 'application/json', 'accept': 'application/json'},
            body: JSON.stringify({
                data: eventData
            })
        })

        if(!apiResponse.ok) {
            return apiResponse.text();
        }else {
           return (typeof apiResponse == 'object') ? apiResponse : apiResponse.json();
        } 
    }

    async _manageFileUpload(event){
        let input = event.currentTarget;
        const fileErr = this.form.querySelector('.file-upload-error');
        const fileName = this.form.querySelector('label.upload-file .file-name');
        const progressMsg = this.form.querySelector('.image-upload-progress-msg');

        fileErr.classList.add('d-none');

        if(input.value == '' || input.files[0] == undefined){
            fileName.innerHTML = 'Upload Image here';
            return;
        }else{
            fileName.innerHTML = input.files[0].name;
        }

        const fileSizeKB = Math.round((input.files[0].size / 1024));
        if(fileSizeKB > 5130){
            fileErr.querySelector('.filesize').innerText = input.files[0].size / (1024**2);
            fileErr.classList.remove('d-none');
        }
        
        const base64 = await Utility.convertImageToBase64(input.files[0]);
        if(base64 == null) return;

        const imageDimentions = await Utility.checkFormDimentions(base64);
        if(imageDimentions.width > 5000 || imageDimentions.height > 5000){
            window.notificationEle.updateNotification('Image size too large!', `maximum dimentions allowed are 5000*5000. Upload image is of ${imageDimentions.width}*${imageDimentions.height}`, {
                type: 'error',
                timeout: 5000
            });
            input.value = null; input.dispatchEvent(new Event('change'));
            return;
        }

        progressMsg.classList.remove('d-none');
        this.submitBtn.disabled = true;
        fetch('https://certificate-manager.diamondrensu.com/api/image/upload', {
            method: 'POST',
            headers: { 
                'Content-type': 'application/json; charset=UTF-8', 
                'X-Shop': '257a2f-1d.myshopify.com'  
            },
            body: JSON.stringify({image: base64})            
        })
        .then((response) => { 
            return response.json()})
        .then((data) => {
            if(data.errors){
                const errorMsg = (data.errors.image) ? JSON.stringify(data.errors.image) : JSON.stringify(data.errors)
                input.value = null; input.dispatchEvent(new Event('change'));
                input.removeAttribute('data-cdn');
                window.notificationEle.updateNotification('Something went wrong!', errorMsg, {
                    type: 'error',
                    timeout: 5000
                });
            }else{
                input.dataset.cdn = data.image_url;
            }
            progressMsg.classList.add('d-none');
            this.submitBtn.removeAttribute('disabled');
        }).catch(error => {
            console.error('Error:', error);
            input.value = null; input.dispatchEvent(new Event('change'));
            input.removeAttribute('data-cdn');
            window.notificationEle.updateNotification('Something went wrong!', error, {
                type: 'error',
                timeout: 5000
            });

            progressMsg.classList.add('d-none');
            this.submitBtn.removeAttribute('disabled');
        }); 
    }
}
typeof lovestoryForm !== 'undefined' && new lovestoryForm();
